var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-logo-highlights-container"},[(_vm.isTextOnly)?_c('CmsComponentsBrandLogoHighlightsTextOnly',{attrs:{"data":_vm.data}}):_c('CmsComponentsBrandLogoHighlightsLogosOnly',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }